export const dateStringOrNull = (date: string | null) =>
  date ? new Date(date).toLocaleDateString() : "—";
